<template>
    <div class="account-content">
        <div class="row">
            <div class="col-xs-12">
                <p class="text-mutted"><b>Preencha a nova senha de sua conta nos campos abaixo:</b></p>
            </div>

            <div class="col-xs-12">
                <div class="form-group" v-bind:class="{'has-error': errors.has('email')}">
                    <input type="email"
                        id="email"
                        v-model="form.email"
                        class="form-control"
                        name="email"
                        placeholder="Email da conta"
                        v-validate="{ required: true }"/>
                    <span class="help-block text-left" v-show="errors.has('email')">
                        <strong>{{ errors.first('email') }}</strong>
                    </span>
                </div>
            </div>

            <div class="col-xs-12">
                <div class="form-group" v-bind:class="{'has-error': errors.has('password')}">
                    <input id="password"
                        v-model="form.password"
                        type="password"
                        class="form-control"
                        name="password"
                        placeholder="Nova senha"
                        v-validate="{ required: true }"
                        minlength="2"
                        required />
                    <span class="help-block text-left" v-show="errors.has('password')">
                        <strong>{{ errors.first('password') }}</strong>
                    </span>
                </div>
            </div>

            <div class="col-xs-12">
                <div class="form-group" v-bind:class="{'has-error': errors.has('password_confirmation')}">
                    <input id="password_confirmation"
                        v-model="form.password_confirmation"
                        type="password"
                        class="form-control"
                        name="password_confirmation"
                        placeholder="Confirme a nova senha"
                        v-validate="{required: true, is: form.password}"
                        minlength="2"
                        required />
                    <span class="help-block text-left" v-show="errors.has('password_confirmation')">
                        <strong>{{ errors.first('password_confirmation') }}</strong>
                    </span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <button type="button" @click="sendForm()" class="btn btn-success btn-block waves-effect waves-light m-t-20 ladda-button password-btn">
                    <span class="ladda-label">Alterar Senha</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['token', 'email'],
    data() {
        return {
            form: {
                password: '',
                password_confirmation: '',
                email: this.email,
            }
        }
    },
    methods: {
        sendForm() {
            this.$validator.validateAll().then(res => {
                if (!res)
                    return;

                let obj = {
                    email: this.form.email,
                    token: this.token,
                    password: this.form.password,
                    password_confirmation: this.form.password_confirmation
                };

                let l = Ladda.create(this.$el.querySelector('.ladda-button'));
                l.start();
                axios.post('/auth/password/reset', obj).then(res => {
                    if (res.data.response) {
                        window.App.success('Senha alterada com sucesso!');
                        location.href = "/";
                    }
                }).finally(() => {
                    l.stop();
                });
            });
        }
    },
    created() {
        const dictionary = {
            messages: {
                required: () => 'Este campo é obrigatório!',
                is: () => 'A senha preenchida deve ser igual nos dois campos.',
                min: () => 'Este campo precisa conter no mínimo 2 caracteres.'
            }
        };
        this.$validator.localize('pt_BR', dictionary);
    }
}
</script>
